
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/book-consultation",
      function () {
        return require("private-next-pages/book-consultation/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/book-consultation"])
      });
    }
  